

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"15","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, rest), ["\n  ", h('circle', {"cx":"7.5","cy":"7","r":"7","fill":"#CCC"}, []), "\n  ", h('path', {"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.33 4.958v-.146c0-.08.066-.145.147-.145h2.041c.08 0 .146.065.146.146v.145a1.167 1.167 0 1 1-2.333 0Zm-1.166 0V3.747c0-.137.11-.247.247-.247h4.173c.136 0 .247.11.247.247v1.211c0 .879-.486 1.644-1.203 2.042A2.333 2.333 0 0 1 9.83 9.042v1.211c0 .137-.11.247-.247.247H5.411a.247.247 0 0 1-.247-.247V9.042c0-.879.486-1.644 1.203-2.042a2.333 2.333 0 0 1-1.203-2.042Zm1.167 4.084v.146c0 .08.065.145.146.145h2.041c.08 0 .146-.065.146-.146v-.145a1.167 1.167 0 1 0-2.333 0Z","fill":"#fff"}, []), "\n"]);
};

        